import React, { useCallback, useEffect } from 'react';
import OnboardingVideo from 'components/OnboardingVideo';
import OverviewLayout from 'components/OverviewLayout/OverviewLayout';
import { useAuth } from 'contexts/auth/auth';
import { useHistory } from 'react-router-dom';
import { ownerUpdateWatchOnboardingVideo } from 'api/owner_sdk';
import { message } from 'antd';
import { useOwnerDetails } from 'api/owners';

const OnboardingVideoPage = () => {
  const { id: ownerId, stores } = useAuth();
  const { data: owner } = useOwnerDetails(ownerId);

  const history = useHistory();

  useEffect(() => {
    // When the user logs in, we send them to this page.
    // If they have already watched the video, we redirect them to the next step on onboarding flow.
    if (owner?.isWatchedOnboardingVideo) {
      history.push({
        pathname: '/onboarding',
        state: { stores, ownerId },
      });
    }
  }, [owner, ownerId, history, stores]);

  const redirectToOnboarding = useCallback(() => {
    ownerUpdateWatchOnboardingVideo()
      .then(() =>
        history.push({
          pathname: '/onboarding',
          state: { stores, ownerId },
        }),
      )
      .catch((error) => message.error(error.message));
  }, [history, ownerId, stores]);

  return (
    <OverviewLayout className="onboarding-page">
      <OnboardingVideo onNext={redirectToOnboarding} />
    </OverviewLayout>
  );
};

export default OnboardingVideoPage;
